<template>
  <div>
    <div v-if="loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="loadpage == false" class="pb-3">
      <b-card no-body>
        <b-card-body class="pb-0" body-bg-variant="light">
          <h2>กล่องค้นหา</h2>
        </b-card-body>
        <hr class="mt-0">

        <!-- srch card -->
        <div class="">
          <b-card-body class="pt-1">
            <b-row>
              <b-col cols="12" md="7">
                <b-form-group label="วันที่ :" label-cols-md="3" label-class="pt-0">
                  <div class="d-md-flex align-items-center">
                    <div class="d-flex">
                      <flat-pickr v-model="date" class="form-control flat_input" :config="datePickerConfig"/>
                      <b-button variant="outline-secondary" size="sm" @click="clearDate(true)">
                        <feather-icon class="text-dark" icon="XIcon" size="22"/>
                      </b-button>
                    </div>
                    <span class="mx-1">-</span>
                    <div class="d-flex">
                      <flat-pickr v-model="dueDate" class="form-control flat_input" :config="datePickerConfig"/>
                      <b-button variant="outline-secondary" size="sm" @click="clearDate(false)">
                        <feather-icon class="text-dark" icon="XIcon" size="22"/>
                      </b-button>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="7">
                <b-form-group label="เลขที่บิล :" label-cols-md="3" label-class="pt-0">
                  <b-form-input v-model="srchPackingID" class="text_input"/>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="7">
                <b-form-group label="เลขแทรค :" label-cols-md="3" label-class="pt-0">
                  <b-form-input v-model="srchTrackingID" class="text_input"/>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="7">
                <b-form-group label="การชำระเงิน :" label-cols-md="3" label-class="pt-0">
                  <b-form-radio-group
                    v-model="srchPaid"
                    :options="srchPaidList"
                    text-field="text"
                  >
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="7">
                <b-form-group label="การจัดส่ง :" label-cols-md="3" label-class="pt-0">
                  <b-form-radio-group
                    v-model="srchShip"
                    :options="srchShipList"
                    text-field="text"
                  >
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="7">
                <b-button variant="primary" @click="loadShipment()">ค้นหา</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </div>
      </b-card>

      <div>
        <!-- pc -->
        <b-card no-body class="d-none d-sm-block">
          <b-card-body>
            <b-table
              responsive
              bordered
              :items="unShipped"
              :fields="billFields"
              table-class="table-md-responsive text-nowrap"
            >
              <template #cell(rowID)="data">
                <div v-if="data.value != 0" class="text-nowrap">
                  <feather-icon
                    :id="`info-${data.value}`"
                    icon="FileTextIcon"
                    class="cursor-pointer text-info"
                    size="20"
                    @click="openModal(data.item)"
                  />
                  <b-tooltip
                    title="ดู"
                    :target="`info-${data.value}`"
                    :delay="{show: '1000'}"
                  />
                </div>
              </template>
              <template #cell(isPaid)="data">
                <div v-if="data.value == true" class="text-success">ชำระยอดแล้ว</div>
                <b-button v-else variant="danger" size="sm" :to="{ name: 'finance-transfer'}">แจ้งชำระเงิน</b-button>
              </template>
              <template #cell(itemList)="data">
                <div v-if="data.item.shippedDate == null" class="text-warning">รอจัดส่ง</div>
                <div v-else class="text-success">จัดส่งแล้ว</div>
              </template>
              <template #cell(created)="data">
                <div>{{formatDatetime(data.value)}}</div>
              </template>
              <template #cell(receiverAddress)="data">
                <div class="text-truncate cursor-pointer" :id="`receiver-${data.item.rowID}`">{{data.value}}</div>
                <b-tooltip
                  :title="data.value"
                  :target="`receiver-${data.item.rowID}`"
                  :delay="{show: '500'}"
                />
              </template>
              <template #cell(senderAddress)="data">
                <div class="text-truncate cursor-pointer" :id="`sender-${data.item.rowID}`">{{data.value}}</div>
                <b-tooltip
                  :title="data.value"
                  :target="`sender-${data.item.rowID}`"
                  :delay="{show: '500'}"
                />
              </template>
              <template #cell(amount)="data">
                <div>{{format_price(data.value)}}</div>
              </template>
              <template #cell(shippedDate)="data">
                <div>{{formatDatetime(data.value)}}</div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>

        <!-- mobile -->
        <div class="d-block d-sm-none">
          <b-card v-for="(item, index) in shipInfoMobile" :key="index" no-body>
            <b-card-header class="align-items-center pb-0">
              <h4 class="font-weight-bolder pt-1">{{item.thaiPackingID}}</h4>
              <b-button v-if="item.isPaid == false" class="float-right" size="sm" variant="danger" :to="{ name: 'finance-transfer'}">แจ้งชำระเงิน</b-button>
            </b-card-header>
            <hr class="dense pb-0">
            <b-card class="px-1" role="tablist" no-body>
              <b-card-body class="py-0 px-0" role="tab">
                <div class="px-0 font-weight-normal">ที่อยู่ : {{item.receiverAddress}}</div>
                <h2 class="px-0 pt-1 text-center">ยอด</h2>
                <h1 class="px-0 text-center">{{format_price(item.amount)}} ฿</h1>
                <div class="pt-0 pb-1 text-center">{{item.totalItemCount}} ชิ้น, {{item.totalItemWeight}} kg, {{item.totalItemCubic}} คิว</div>
                <div class="px-0 font-weight-normal">สถานะ :
                  <span :class="item.isPaid == true ? 'text-success' : 'text-danger'">{{item.statusDescription}}</span>
                </div>
                <div class="px-0 font-weight-normal">วันที่แพ็ค : {{formatDatetime(item.created)}}</div>
                <div class="px-0 font-weight-normal">วันที่จัดส่ง : {{formatDatetime(item.shippedDate)}}</div>
                <div class="px-0 font-weight-normal">ขนส่ง : {{item.expressCompanyName}}</div>
                <div class="px-0 font-weight-normal h5">TrackingNo : {{item.shipTrack}}</div>
                <div class="text-right align-items-center">
                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                    v-b-toggle="'billUn-'+index"
                    @click="loadTrackingList(item.thaiPackingID, item.shippedDate)"
                  >
                    <span>เพิ่มเติม </span>
                    <span class="when-opened">
                      <feather-icon icon="ChevronUpIcon" />
                    </span>
                    <span class="when-closed">
                      <feather-icon icon="ChevronDownIcon" />
                    </span>
                  </b-button>
                </div>
              </b-card-body>
              <b-collapse :id="'billUn-'+index" accordion="billUn" role="tabpanel">
                <div v-if="loadexpand == false" class="text-center">
                  <b-spinner
                    style="width: 5rem; height: 5rem;"
                    variant="primary"
                    label="Large Spinner"
                  />
                </div>
                <div v-if="loadexpand == true">
                  <hr class="dense">
                  <b-card-body v-for="(list, index) in trackListMobile" :key="index" class="py-0">
                    <div role="tablist">
                      <b-row>
                        <b-col><h5>{{list.trackingNo}}</h5></b-col>
                        <b-col class="text-right"><h5>{{format_price(list.shippingPrice)}} ฿</h5></b-col>
                      </b-row>
                      <div v-if="list.remark" class="h5">{{list.remark}}</div>
                      <div v-if="list.remark == '' && list.orderID && list.rowNo" class="h5">
                        <h5>ออเดอร์ : {{list.orderID}}</h5>
                        <h5>ลำดับ : {{list.rowNo}}</h5>
                      </div>
                      <div role="tab" class="text-right">
                        <b-button
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary"
                          class="btn-icon rounded-circle"
                          v-b-toggle="'list-'+index"
                        >
                          <span>เพิ่มเติม </span>
                          <span class="when-opened">
                            <feather-icon icon="ChevronUpIcon" />
                          </span>
                          <span class="when-closed">
                            <feather-icon icon="ChevronDownIcon" />
                          </span>
                        </b-button>
                      </div>
                      <b-collapse class="pt-1" :id="'list-'+index" role="tabpanel">
                        <div>รับเข้าโกดังจีน : {{formatDatetime(list.receiveDate)}}</div>
                        <div>ส่งออกจากจีน : {{formatDatetime(list.offChinaDate)}}</div>
                        <div>ถึงโกดังไทย : {{formatDatetime(list.arrivedThaiDate)}}</div>
                        <div>แจ้งส่งทาง : {{list.informTransportType}}</div>
                        <div>ขนส่งจริงทาง : {{list.actualTransportType}}</div>
                        <div>น้ำหนัก : {{list.weight}} kg.</div>
                        <div>ขนาด : {{list.cubic1}} x {{list.cubic2}} x {{list.cubic3}} = {{format_decimal(list.cubic)}} คิว</div>
                        <div>เรท : {{list.rate}}</div>
                        <div>ราคา : {{format_price(list.shippingPrice)}}</div>
                        <div v-if="list.photoList.length != 0" class="text-right">
                          <b-link @click="openPhotos(list.photoList)"><u>ดูรูป</u></b-link>
                        </div>
                      </b-collapse>
                    </div>
                    <hr class="dense">
                  </b-card-body>
                  <b-pagination
                    v-model="mSubCurrentPage"
                    :total-rows="mSubTotalRows"
                    :per-page="mSubPerPage"
                    align="center"
                  ></b-pagination>
                  <div v-if="item.isPaid == false" >
                    <span class="title pr-1">โค้ดคูปอง : </span>
                    <div class="d-flex align-items-center">
                      <b-form-input v-model="item.coupon" class="col-7" size="sm"/>
                      <b-button class="ml-1" variant="outline-primary" size="sm" @click="useCoupon(item.thaiPackingID, item.coupon)">
                        ใช้คูปอง
                      </b-button>
                    </div>
                  </div>

                  <b-table
                    responsive
                    class="pt-1"
                    :items="item.summaryList"
                    :fields="summaryFields"
                    thead-class="hidden_header"
                    :tbody-tr-class="rowClass"
                    small
                  >
                    <template #cell(amount)="data">
                      {{format_price(data.value)}}
                    </template>
                    </b-table>
                </div>
              </b-collapse>
            </b-card>
          </b-card>
          <div class="overflow-auto pb-1">
            <b-pagination
              v-model="mCurrentPage"
              :total-rows="mTotalRows"
              :per-page="mPerPage"
              align="center"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- bill info -->
      <b-modal
        id="track-list"
        ref="track-list"
        size="xl"
        hide-footer
        @hidden="closeModal"
      >
        <div v-if="loadtable == false" class="text-center">
          <b-spinner
            style="width: 5rem; height: 5rem;"
            variant="primary"
            label="Large Spinner"
          />
        </div>
        <div v-if="loadtable == true">
          <div class="h5 font-weight-bolder">{{itemInfo.thaiPackingID}}</div>
          <b-row>
            <b-col v-if="itemInfo.senderAddress != null || itemInfo.shippedDate == null" class="col-12 col-md-2">
              ที่อยู่ส่งในนาม :
            </b-col>
            <b-col class="col-12 col-md-9 pb-1 pb-md-0">
              <span v-if="itemInfo.senderAddress != null">{{itemInfo.senderAddress}}</span>
              <b-link v-if="itemInfo.shippedDate == null" @click="openChange(true)">
                <u> เปลี่ยนที่อยู่</u>
              </b-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="itemInfo.receiverAddress != null || itemInfo.shippedDate == null" class="col-12 col-md-2">
              ที่อยู่ผู้รับ :
            </b-col>
            <b-col class="col-12 col-md-9">
              <span v-if="itemInfo.receiverAddress != null">{{itemInfo.receiverAddress}}</span>
              <b-link v-if="itemInfo.shippedDate == null" @click="openChange(false)">
                <u> เปลี่ยนที่อยู่</u>
              </b-link>
            </b-col>
          </b-row>
          <div class="text-right pb-1">
            <vue-excel-xlsx
              id="excel"
              v-show="false"
              :data="dataList"
              :columns="excelFields"
              :file-name="'บิลค่าขนส่ง' + ' - ' + this.billNumForExcel"
              :file-type="'xlsx'"
              :sheet-name="'sheetname'"
            >
            </vue-excel-xlsx>
            <b-button variant="success" size="sm" @click="exportExcel()">
              <feather-icon icon="FileTextIcon"/>
              Excel
            </b-button>
          </div>

          <b-table
            responsive
            bordered
            :per-page="perPage"
            :current-page="currentPage"
            :items="trackList"
            :fields="detailFields"
            @filtered="onFiltered"
            table-class="table-responsive text-nowrap"
          >
            <template #cell(no)="data">
              {{data.index + 1 + ((currentPage - 1) * 10)}}
            </template>
            <template #cell(photoList)="data">
              <div v-if="data.item.photoList.length != 0">
                <b-img :src="data.item.photoList[0]" width="30px" @click="openPhotos(data.value)" class="cursor-pointer"></b-img>
              </div>
            </template>
            <template #cell(receiveDate)="data">
              <div>
                <span>รับเข้าจีน : </span>
                {{formatDatetime(data.value)}}
              </div>
              <div>
                <span>ออกจากจีน : </span>
                {{formatDatetime(data.item.offChinaDate)}}
              </div>
              <div>
                <span>ถึงไทย : </span>
                {{formatDatetime(data.item.arrivedThaiDate)}}
              </div>
            </template>
            <template #cell(weight)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(cubic1)="data">
              {{data.value}} x {{data.item.cubic2}} x {{data.item.cubic3}}
            </template>
            <template #cell(cubic)="data">
              {{format_decimal(data.value)}}
            </template>
            <template #cell(rate)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(shippingPrice)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(chinaDeliveryPrice)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(makeboxPrice)="data">
              {{format_price(data.value)}}
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-0 mb-2"
          />

          <b-row align-h="end">
            <b-col class="col-md-8 col-lg-6">
              <div v-if="itemInfo.isPaid == false" class="d-flex align-items-center">
                <span class="title pr-1">โค้ดคูปอง</span>
                <b-form-input v-model="itemInfo.coupon" class="col-7" size="sm"/>
                <b-button class="ml-1" variant="outline-primary" size="sm" @click="useCoupon(itemInfo.thaiPackingID, itemInfo.coupon)">
                  ใช้คูปอง
                </b-button>
              </div>
              <b-table
                responsive
                class="position-relative pt-1"
                :items="itemInfo.summaryList"
                :fields="summaryFields"
                thead-class="hidden_header"
                small
                :tbody-tr-class="rowClass"
              >
                <template #cell(amount)="data">
                  <div>{{format_price(data.value)}}</div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <!-- change address -->
      <b-modal
        id="change-address"
        ref="change-address"
        title-class="h2"
        :title="this.isSender == true ? 'เปลี่ยนที่อยู่ส่งในนาม' : 'เปลี่ยนที่อยู่ผู้รับ'"
        @hidden="closeChange"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        :size="this.tabsChange == 0 ? 'lg' : 'md'"
      >
        <b-form>
          <b-card-body class="py-0 px-0">
            <b-tabs v-model="tabsChange">
              <b-tab title="ที่อยู่ในระบบ">
                <b-row class="d-md-flex align-items-center py-1">
                  <div class="col-12 col-md-10 d-md-flex align-items-center">
                    <div class="col-12 col-md-1 pl-0 pr-0">ค้นหา :</div>
                    <b-form-input v-model="srchAddress" class="col-12 col-md-11"/>
                  </div>
                  <div class="col-12 col-md-2 pt-1 pt-md-0">
                    <b-button variant="primary" @click="getChangeAddress">ค้นหา</b-button>
                  </div>
                </b-row>
                <div v-if="loadChangeAddress == false" class="text-center">
                  <b-spinner
                    style="width: 5rem; height: 5rem;"
                    variant="primary"
                    label="Large Spinner"
                  />
                </div>
                <div v-if="loadChangeAddress == true">
                  <div class="text-right pt-1">จำนวนทั้งหมด : {{this.totalRowsChng}}</div>
                  <b-table
                    bordered
                    responsive
                    :items="changeAddressList"
                    :fields="changeAddressFields"
                    table-class="table-responsive text-nowrap"
                  >
                    <template #cell(addressID)="data">
                      <!-- <b-form-checkbox v-model="changeAddressSel" :value="data.item"/> -->
                      <b-form-radio v-model="changeAddressSel" :value="data.item"></b-form-radio>
                    </template>
                    <template #cell(name)="data">
                      คุณ {{data.item.name}} โทร: {{data.item.phone}} {{data.item.address}} {{data.item.tambon}} {{data.item.amphoe}} {{data.item.province}} {{data.item.postcode}}
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="currentPageChng"
                    :total-rows="totalRowsChng"
                    :per-page="perPageChng"
                    align="center"
                    size="sm"
                    class="my-0"
                  />
                </div>
              </b-tab>

              <b-tab title="ที่อยู่ใหม่">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-slim"
                      label="ชื่อ :"
                    >
                      <div class="align-items-center">
                        <b-form-input v-model="addressName"/>
                        <small v-if="this.valName == false" class="text-danger">กรุณาระบุ</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-slim"
                      label="เบอร์โทร :"
                    >
                      <div class="align-items-center">
                        <b-form-input v-model="addressPhone"/>
                        <small v-if="this.valPhone == false" class="text-danger">กรุณาระบุ</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-slim"
                      label="ที่อยู่ :"
                    >
                      <div class="align-items-center">
                        <b-form-textarea v-model="addressDetail"/>
                        <small v-if="this.valAddress == false" class="text-danger">กรุณาระบุ</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-slim"
                      label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :"
                    >
                      <div class="align-items-center">
                        <v-select
                          class="px-0 col-12"
                          v-model="postcode"
                          :options="postcodeMapping"
                          label="list"
                        ></v-select>
                        <small v-if="this.valPostcode == false" class="text-danger">กรุณาระบุ</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card-body>
          <div class="text-right pt-1">
            <b-button @click="closeChange" variant="outline-danger">ยกเลิก</b-button>
            <b-button @click="changeAddress()" class="ml-1" variant="primary" :disabled="this.loadChange == false">
              <b-spinner v-if="this.loadChange == false" small/>
              บันทึก
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- show img -->
      <b-modal ref="show-img" hide-footer centered>
        <div v-for="(item, index) in trackPhotoList" :key="index" class="text-center pb-1">
          <b-img class="px-0" :src="item" fluid ></b-img>
        </div>
      </b-modal>

    </div>
  </div>
</template>
<script>
import {
  BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BImg,
  BCardHeader, BCollapse, BContainer, VBToggle, BLink, BTooltip, BModal, VBModal,
  BFormRadioGroup, BFormRadio, BForm, BFormTextarea
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price, formatDatetime, format_decimal } from '@/views/global_function.js'
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
import { header_token } from '@/views/token'
export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },

  components: {
    BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
    BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BImg,
    BCardHeader, flatPickr, BCollapse, BContainer, VBToggle, BLink, BTooltip, BModal,
    BFormRadioGroup, BFormRadio, BForm, vSelect, BFormTextarea
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      allOpenRows: [],
      date: null,
      dueDate: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      srchPackingID: '',
      srchTrackingID: '',
      srchPaid: false,
      srchPaidList: [
        { text: 'ทั้งหมด', value: null },
        { text: 'ชำระแล้ว', value: true },
        { text: 'ยังไม่ชำระ', value: false },
      ],
      srchShip: null,
      srchShipList: [
        { text: 'ทั้งหมด', value: null },
        { text: 'จัดส่งแล้ว', value: true },
        { text: 'ยังไม่จัดส่ง', value: false },
      ],
      unShipped: [],
      shipped: [],
      unShippedCount: '',
      shippedCount: '',
      shipDetail: [],
      shipDetailList: [],
      rowIndex: [],
      coupon: '',
      waitDetail: true,

      billFields: [
        {key: 'rowID', label: 'รายละเอียด', thClass: 'text-center', tdClass: 'text-center' },
        {key: 'isPaid', label: 'การชำระเงิน', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'itemList', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'thaiPackingID', label: 'เลขบิล', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'created', label: 'วันที่แพ็ค', thClass: 'text-center' },
        {key: 'amount', label: 'ยอดรวม', thClass: 'text-center', tdClass: 'text-right'},
        {key: 'expressCompanyName', label: 'ขนส่ง', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'receiverAddress', label: 'ที่อยู่ผู้รับ', thClass: 'text-center', tdClass: 'text-address'},
        {key: 'senderAddress', label: 'ส่งในนาม', thClass: 'text-center', tdClass: 'text-address'},
        {key: 'shippedDate', label: 'วันที่ส่ง', thClass: 'text-center' },
        {key: 'shipTrack', label: 'TrackingNo', thClass: 'text-center', tdClass: 'text-center'},
      ],

      detailFields: [
        { key: 'no', label: 'No', field: 'no', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'trackingNo', label: 'เลขแทรค', field: 'trackingNo' },
        { key: 'photoList', label: 'รูป', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'remark', label:'หมายเหตุ', field: 'remark' },
        { key: 'orderID', label:'ออเดอร์', field: 'orderID' },
        { key: 'rowNo', label:'ลำดับ', field: 'rowNo' },
        { key: 'receiveDate', label:'สถานะการจัดส่ง', field: 'receiveDate' },
        { key: 'weight', label:'น้ำหนัก', field: 'weight', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'cubic1', label:'ขนาด', field: 'cubic1', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'cubic', label:'ขนาด(คิว)', field: 'cubic', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'actualTransportType', label:'ขนส่ง', field: 'actualTransportType' },
        { key: 'rate', label:'เรท', field: 'rate', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'shippingPrice', label:'ราคา', field: 'shippingPrice', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'chinaDeliveryPrice', label:'ค่าส่งเก็บปลายทาง', field: 'chinaDeliveryPrice', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'makeboxPrice', label:'ค่าตีลังไม้', field: 'makeboxPrice', thClass: 'text-right', tdClass: 'text-right' },
      ],
      dataList: [],
      trackPhotoList: [],

      excelFields: [
        { key: 'no', label: 'No', field: 'no', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'trackingNo', label: 'เลขแทรค', field: 'trackingNo' },
        { key: 'remark', label:'หมายเหตุ', field: 'remark' },
        { key: 'orderID', label:'ออเดอร์', field: 'orderID' },
        { key: 'rowNo', label:'ลำดับ', field: 'rowNo' },
        { key: 'receiveDate', label:'รับของเข้าโกดัง', field: 'receiveDate' },
        { key: 'offChinaDate', label:'ออกจากจีน', field: 'offChinaDate' },
        { key: 'arrivedThaiDate', label: 'ถึงไทยวันที่', field: 'arrivedThaiDate' },
        { key: 'weight', label:'น้ำหนัก', field: 'weight', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'cubic1', label:'ขนาด', field: 'cubic1', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'cubic', label:'ขนาด(คิว)', field: 'cubic', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'actualTransportType', label:'ขนส่ง', field: 'actualTransportType' },
        { key: 'rate', label:'เรท', field: 'rate', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'shippingPrice', label:'ราคา', field: 'shippingPrice', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'chinaDeliveryPrice', label:'ค่าส่งเก็บปลายทาง', field: 'chinaDeliveryPrice', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'makeboxPrice', label:'ค่าตีลังไม้', field: 'makeboxPrice', thClass: 'text-right', tdClass: 'text-right' },
      ],

      trackList: [],
      itemInfo: [],
      summaryFields:[
        { key: 'description' },
        { key: 'amount', tdClass: 'text-right'},
        { key: 'unit', tdClass: 'text-right'},
      ],
      count: 1,

      perPage: 10,
      currentPage: 1,
      totalRows: 1,

      shipInfoMobile: [],
      mPerPage: 10,
      mCurrentPage: 1,
      mTotalRows: 1,

      trackListMobile: [],
      mSubPerPage: 10,
      mSubCurrentPage: 1,
      mSubTotalRows: 1,

      dateForTrack: null,
      dueDateForTrack: null,

      billNumForExcel: '',

      //change address
      addressName: '',
      addressPhone: '',
      addressDetail: '',
      postcodeMapping: [],
      postcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'},
      thaiPackingRowID: null,
      isSender: null,

      valName: true,
      valPhone: true,
      valAddress: true,
      valPostcode: true,

      //address list
      tabsChange: 0,
      changeAddressSel: null,
      changeAddressList: [],
      changeAddressFields: [
        { key: 'addressID', label: 'เลือก', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: "1%" } },
        { key: 'name', label: 'ที่อยู่' }
      ],
      srchAddress: '',
      loadChangeAddress: true,

      perPageChng: 10,
      currentPageChng: 1,
      totalRowsChng: 1,

      // load
      loadpage: true,
      loadShipmentTab: false,
      loadtable: true,
      loadexpand: true,
      loadChange: true,
    };
  },

  watch: {
    mCurrentPage() {
      var skip = (this.mCurrentPage - 1) * 10
      var take = skip + 10
      this.shipInfoMobile = this.unShipped.slice(skip, take)
    },
    mSubCurrentPage() {
      var skip = (this.mSubCurrentPage - 1) * 10
      var take = skip + 10
      this.trackListMobile = this.trackList.slice(skip, take)
    },
    currentPageChng() {
      this.getChangeAddress()
    },
  },

  async created() {
    await this.loadShipment()
    this.getPostcode()
  },

  methods: {
    format_price,
    formatDatetime,
    format_decimal,
    clearDate(type) {
      if (type == true) {
        this.date = null
      } else {
        this.dueDate = null
      }
    },
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping .push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },
    async loadShipment() {
      this.unShipped = []
      this.loadpage = true
      let response = await axios.post(
        taobaoService_dotnet + 'app/Shipment/load-shipment-page-v3',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": this.dueDate == '' ? null : this.date,
          "endDate": this.dueDate,
          "isMobile": false,
          "thaiPackingID": this.srchPackingID,
          "trackingNo": this.srchTrackingID,
          "isPaid": this.srchPaid,
          "isShip": this.srchShip
        },
        { headers: header_token }
      );
      if (response.data.unShippedData != null) {
        response.data.unShippedData.forEach( (e) => {
          this.unShipped.push(e)
        })
      }
      if (response.data.shippedData != null) {
        response.data.shippedData.forEach( (e) => {
          this.unShipped.push(e)
        })
      }
      this.mTotalRows = this.unShipped.length
      this.shipInfoMobile = this.unShipped.slice(0, 10)
      this.date = response.data.startDate
      this.dueDate = response.data.endDate
      this.dateForTrack = response.data.startDate
      this.dueDateForTrack = response.data.endDate
      this.loadpage = false
    },
    async loadTrackingList(packId, ship) {
      this.loadexpand = false
      var isShiped
      if (ship == null) {
        isShiped = false
      } else {
        isShiped = true
      }
      let response = await axios.post(
        taobaoService_dotnet + 'app/Shipment/load-tracking-info',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "thaiPackingID": packId,
          "startDate": this.dateForTrack,
          "endDate": this.dueDateForTrack,
          "isShiped": isShiped
        },
        { headers: header_token }
      );
      this.totalRows = response.data.length
      this.mSubTotalRows = response.data.length
      this.trackList = await response.data
      this.trackListMobile = await response.data.slice(0, 10)
      this.currentPage = 1
      this.loadexpand = true
    },
    async getChangeAddress(){
      this.loadChangeAddress = false
      var skip = 0
      skip = (this.currentPageChng - 1) * 10
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address-v2',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          "isReceiver": !this.isSender,
          "address": this.srchAddress,
          "skip": skip,
          "take": 10
        },
        { headers: header_token }
      );
      this.changeAddressList = response.data.dataList
      this.totalRowsChng = response.data.totalRows
      this.loadChangeAddress = true
    },
    async changeAddress() {
      this.loadChange = false
      if (this.tabsChange == 1 && this.addressName == '') {
        this.valName = false
      } else if(this.tabsChange == 1 && this.addressPhone == '') {
        this.valPhone = false
      } else if(this.tabsChange == 1 && this.addressDetail == '') {
        this.valAddress = false
      } else if(this.tabsChange == 1 && (this.postcode == null || this.postcode.rowID == null)) {
        this.valPostcode = false
      } else if (this.tabsChange == 0 && this.changeAddressSel == null) {
        this.$swal({
          position: 'top',
          title: 'กรุณาเลือกที่อยู่ !',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Shipment/add-shipment-address',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "name": this.addressName,
            "phone": this.addressPhone,
            "address": this.addressDetail,
            "postcodeMappingID": this.tabsChange == 0 ? 0 : this.postcode.rowID,
            "thaiPackingRowID": this.thaiPackingRowID,
            "addressID": this.tabsChange == 0 ? this.changeAddressSel.addressID : 0,
            "isSender": this.isSender
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เปลี่ยนที่อยู่สำเร็จ',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.closeChange()
          this.closeModal()
          this.loadShipment()
        }
      }
      this.loadChange = false
    },
    async openChange(stat) {
      if (this.itemInfo.isAddressPrinted == false) {
        this.thaiPackingRowID = this.itemInfo.rowID
        this.isSender = await stat
        this.getChangeAddress()
        this.$refs['change-address'].show()
      } else {
        this.$swal({
          position: 'top',
          title: 'ไม่สามารถแก้ไขได้ !',
          text: 'ที่อยู่จัดส่งถูกปริ้นไปแล้ว ไม่สามารถแก้ไขได้ !',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      }
    },
    closeChange() {
      this.addressName = ''
      this.addressPhone = ''
      this.addressDetail = ''
      this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'}
      this.thaiPackingRowID = null
      this.isSender = null
      this.valName = true
      this.valPhone = true
      this.valAddress = true
      this.valPostcode = true

      this.tabsChange = 0
      this.changeAddressSel = null
      this.srchAddress = ''
      this.currentPageChng = 1

      this.$refs['change-address'].hide()
    },

     onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.description == 'รวม') return 'table-success'
    },
    rowClassM(item, type) {
      if (!item || type != 'row') return
      if (item.description == 'รวม') return 'table-success'
    },
    async useCoupon(id, code){
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "loginToken": this.userData.data.customerInfo.loginToken,
        "thaiPackingID": id,
        "couponCode": code
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Shipment/use-coupon-code-V2',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      if (keepdata.status == 'error') {
        this.$swal({
          title: 'ไม่สามารถใช้คูปอง ' + code + ' ได้',
          text: keepdata.error_description + (keepdata.useDate != null ? ' (ใช้ได้ ' + formatDatetime(keepdata.useDate) + ')' : ''),
          icon: 'warning',
          confirmButtonText: 'เข้าใจแล้ว',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'ใช้คูปองเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.shipDetailList = await []
        this.loadShipment()
      }
    },
    async openModal(item)
    {
      this.loadtable = false
      this.$refs['track-list'].show()
      this.itemInfo = item
      this.billNumForExcel = item.thaiPackingID
      await this.loadTrackingList(item.thaiPackingID, item.shippedDate)
      this.loadtable = true
    },
    closeModal() {
      this.itemInfo = []
      this.totalRows = 1
      this.trackList = []
      this.billNumForExcel = ''
      this.$refs['track-list'].hide()
    },
    openPhotos(item) {
      this.trackPhotoList = item
      this.$refs['show-img'].show()
    },
    async exportExcel() {
      this.dataList = []
      var no = 0
      await this.trackList.forEach((e) => {
        no += 1
        this.dataList.push({
          'no': no,
          'trackingNo': e.trackingNo,
          'remark': e.remark,
          'orderID': e.orderID,
          'rowNo': e.rowNo,
          'receiveDate': formatDatetime(e.receiveDate),
          'offChinaDate': formatDatetime(e.offChinaDate),
          'arrivedThaiDate': formatDatetime(e.arrivedThaiDate),
          'weight': format_price(e.weight),
          'cubic1': e.cubic1 + ' x ' + e.cubic2 + ' x ' + e.cubic3,
          'cubic': format_decimal(e.cubic),
          'actualTransportType': e.actualTransportType,
          'rate': format_price(e.rate),
          'shippingPrice': format_price(e.shippingPrice),
          'chinaDeliveryPrice': format_price(e.chinaDeliveryPrice),
          'makeboxPrice': format_price(e.makeboxPrice),
        })
      })
      document.getElementById("excel").click();
    }
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  @media (min-width: 768px) {
    .flat_input {
      width: 135px;
    }
    .text_input {
      width: 409px;
    }
  }
</style>
<style scoped lang="scss">
  p {
    margin: 0;
  }
  .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
      display: none;
  }
</style>
<style>
  .hidden_header {
    display: none;
  }

  .text-address {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
  }

  /* td{
    color: black !important;
  }
  th{
    color: black !important;
  } */
</style>